import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function azureBlob(data, token) {
  // console.log("in api")
  return axios.post(APP_SETTINGS.API_PATH.DIGITAL_OCEAN.digitalOcean, data, {
    headers: { Authorization: "Bearer " + token },
  });
}
